import { request } from "../network/request";
const db = "dn0";
export function login(data) {
  return request({
    url: "auth/login.json",
    method: "post",
    data,
  });
}

//获取当前时间一年内的周期列表
export function getWeeklyList(tjrq) {
  return request({
    url: "system/getWeeklyList",
    method: "get",
    params: {
      db,
      tjrq,
    },
  });
}

export function fetchDeptUserList() {
  return request({
    url: '/system/getDeptUserList',
    method: 'get',
    params: {},
  })
}

export function fetchUserInfo() {
  return request({
    url: '/system/getUser',
    method: 'get',
    params: {},
  })
}

// 获取问题类型
export function fetchQuestionTx() {
  return request({
    url: '/system/getDictData',
    method: 'get',
    params: {
      dictType: "pmp_quality_line",
      type: "1"
    },
  })
}

export function fetchQuestionJd() {
  return request({
    url: '/system/getDictData',
    method: 'get',
    params: {
      dictType: "pmp_course_step",
      type: "1"
    },
  })
}

export function getDict(dictType, type) {
  return request({
    url: '/system/getDictData',
    method: 'get',
    params: {
      dictType: dictType,
      type: type
    },
  })
}
//根据数据类型获取字典列表
export function getDictData(dictType, type) {
  return request({
    url: "system/getDictData",
    method: "get",
    params: {
      dictType,
      type,
    },
  });
}

export function getBmxxList(params) {
  return request({
    url: "system/getBmxxList",
    method: "get",
    params: {
      db,
      ...params,
    },
  });
}

/**
 * 获取项目信息列表
 * @param {*} xmlx 项目类型，多个,隔开，如DS,SW,SD,TS ; 0-全部
 * @param {*} range 数据范围 1-角色数据权限 0-全部  
 * @param {*} xmzt 项目状态，多个,隔开，如1,3 ; 0-全部
 * @param {*} bmbh 部门编号
 * @param {*} xmjd 项目阶段
 * @returns
 */
export function getXmxxList(params) {
  if (!params.xmzt) {
    params.xmzt = '0'
  }
  return request({
    url: "system/getXmxxList",
    method: "get",
    params: {
      db,
      ...params
    },
  });
}
/**
 * 咨询总监
 * @param {*} params 
 * @returns 
 */
export function getPersonAdviceList(params) {
  return request({
    url: "system/getPersonAdviceList",
    method: "get",
    params: {
      db,
      ...params
    },
  });
}
/**
 * 项目总监
 * @param {*} params 
 * @returns 
 */
export function getXmzjList(params) {
  return request({
    url: "system/getXmzjList",
    method: "get",
    params: {
      db,
      ...params
    },
  });
}

